"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topBar = exports.bottomBar = exports.charts = void 0;

var _util = require("../../../util");

const charts = () => ({
  width: 20
});

exports.charts = charts;

const bottomBar = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'positive'
  } = cssProps;
  return {
    backgroundColor: (0, _util.color)(theme, variant === 'positive' ? 'data.positiveSubtle' : 'data.negativeSubtle'),
    borderRadius: 2,
    height: (0, _util.spacing)(theme, 'xxsmall'),
    maxWidth: '100%',
    minWidth: 0
  };
};

exports.bottomBar = bottomBar;

const topBar = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'positive'
  } = cssProps;
  return {
    backgroundColor: (0, _util.color)(theme, variant === 'positive' ? 'data.positiveSubtle' : 'data.negativeSubtle'),
    borderRadius: 2,
    height: (0, _util.spacing)(theme, 'xsmall'),
    margin: (0, _util.spacing)(theme, ['none', 'none', 'xsmall', 'none']),
    maxWidth: '100%',
    minWidth: 0
  };
};

exports.topBar = topBar;
//# sourceMappingURL=MiniHorizontalBarChart.style.js.map